import { billCycle } from "./types";
import { ICardListResponse } from "../../../services/card-list/card-list.interface";

const formatPlanPrice = (amount: number | string | null | undefined): string => {
  const numericAmount = typeof amount === "string" ? Number(amount) : (amount ?? 0);
  if (!Number.isFinite(numericAmount)) return "$0";

  if (Number.isInteger(numericAmount)) return `$${numericAmount}`;
  return `$${numericAmount.toFixed(2)}`;
};

export const getPrices = (wellnessPurchaseData: any) => ({
  perYear: {
    amount: wellnessPurchaseData?.price,
    enrollmentFee: 0,
    planId: wellnessPurchaseData?.planId || 4,
  },
  perMonth: {
    amount: wellnessPurchaseData?.monthlyPrice,
    enrollmentFee: wellnessPurchaseData?.oneTimeDownpayment || 0,
    planId: wellnessPurchaseData?.planIdMonthly || 3,
  },
});

export const getPaymentSummary = (
  billingCycle: billCycle,
  planName: string | undefined,
  prices: ReturnType<typeof getPrices>,
) => {
  return [
    {
      description: `${planName}`,
      amount: formatPlanPrice(prices[billingCycle].amount),
    },
    {
      description: "Total Due Today",
      amount: formatPlanPrice(prices[billingCycle].amount),
      isBold: true,
    },
  ];
};

export const getFilteredPaymentList = (
  cardList: ICardListResponse,
  cardSelectedId: string | null,
) => {
  if (cardSelectedId) {
    return cardList?.cards.filter((card) => card.id === cardSelectedId);
  }
  return cardList?.cards.filter((card) => card.isDefault);
};

export const formatBirthdate = (birthdate: string | null | undefined): string | null => {
  if (!birthdate) return null;
  return new Date(parseInt(birthdate) * 1000).toLocaleDateString("en-US");
};

export const openExternalLink = (url: string) => {
  window.open(url, "_blank");
};

export const getScratchPayEligibilityState = (
  eligibilityLoading: boolean,
  eligibilityError: any,
  eligible: boolean | undefined,
) => {
  if (eligibilityLoading) {
    return { isEligible: false, text: "Checking eligibility..." };
  }
  if (eligibilityError) {
    return {
      isEligible: false,
      text: "Unable to verify eligibility. Please try annual payment.",
    };
  }
  return { isEligible: eligible ?? false, text: "" };
};

